export enum DeleteModalTypeEnum {
  DELETE_VENDOR = 'DELETE_VENDOR',
  DELETE_GLOBAL_CONTROL = 'DELETE_GLOBAL_CONTROL',
  DELETE_QUESTIONNAIRE_VENDOR = 'DELETE_QUESTIONNAIRE_VENDOR',
  SEND_REMINDER_VENDOR = 'SEND_REMINDER_VENDOR',
  UNLINK_ARTIFACT = 'UNLINK_ARTIFACT',
}
